export default __webpack_public_path__ + "static/media/2.739b4091.png";